
export function clearCookie() {
    localStorage.setItem('userInfoMd', ''); // 用户信息
    localStorage.setItem('pubconfiginfo', ''); // 公共服务基础配置
}


// WEBPACK FOOTER //
// ./src/util/celecookie.js